import axios from 'axios';

const API = axios.create({
          baseURL: process.env.NODE_ENV === 'production' 
            ? 'https://zaptude.levrotec.com/api' 
            : 'http://localhost:5000/api',
});

API.interceptors.request.use((req) => {
          const token = localStorage.getItem("token");

          if (token) {
                      req.headers.Authorization = `Bearer ${token}`;
                    }

          return req;
}, (error) => {
          return Promise.reject(error);
});

export default API;
